module.exports = __webpack_public_path__ + "static/who-asked-you-512d6a81340cacbc0bb2d48576eb1a0d.jpg";